import React, { useCallback, useMemo, useState } from "react";
import { Button, Popover, Stack, Typography } from "@mui/material";

import { useDealActions, useDealCurrencySelect } from "store";
import { DataItem, SingleCharForm } from "../Single-char-form/SingeCharForm";

interface IProps {
  onSuccess: () => Promise<void>;
  isAdmin: boolean;
  disablePopup?: boolean;
  dealId: number;
}

export const Currency: React.FC<IProps> = ({ isAdmin, disablePopup, dealId, onSuccess }) => {
  const currency = useDealCurrencySelect();

  if (!isAdmin) return null;

  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const { updateCharacteristicDataAction } = useDealActions();

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  const triggerDisplayValue: string = useMemo(() => {
    let displayValue = "N/A";
    if (!currency) return displayValue;

    const { is_multiple, data } = currency;

    if (is_multiple && data.length > 1) {
      displayValue = "Multiple";
    }

    if (is_multiple && data.length === 1) {
      displayValue = data[0].value;
    }

    if (!is_multiple && data.length >= 1) {
      displayValue = data[0].value;
    }

    return displayValue;
  }, [currency]);

  const handleSubmit = useCallback(
    async (state: DataItem[]) => {
      if (!currency) return;
      await updateCharacteristicDataAction({
        characteristic_id: currency.id,
        deal_id: dealId,
        characteristic_data: state
      });
      handleClose();
      onSuccess();
    },
    [currency, dealId]
  );
  return (
    <>
      <Button
        sx={{
          color: "#5d7782",
          padding: "0 10px",
          minWidth: "auto",
          fontSize: "15px",
          backgroundColor: "#edf1f9",
          minHeight: "28px",
          maxHeight: "28px"
        }}
        onClick={(e) => !disablePopup && isAdmin && handleClick(e)}
        className="trigger"
      >
        <Stack
          direction="row"
          sx={{
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            overflow: "hidden",
            maxWidth: "200px",
            fontSize: "12px",
            fontWeight: "400"
          }}
          gap="5px"
        >
          <Typography sx={{ color: "#496682" }}>Currency:</Typography>
          <Typography sx={{ color: "#071F35", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden" }}>
            {triggerDisplayValue}
          </Typography>
        </Stack>
      </Button>
      {currency && (
        <Popover
          open={open}
          onClose={handleClose}
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left"
          }}
        >
          <SingleCharForm characteristic={currency} deal_id={dealId} onCancel={handleClose} onSubmit={handleSubmit} />
        </Popover>
      )}
    </>
  );
};
